export default __webpack_public_path__ + "static/media/kubernetes.16cd64bf.svg";